export enum OperatorEnum {
    Equals = 'eq',
    NotEquals = 'notEq',
    LessThan = 'lt',
    LessThanOrEqual = 'lte',
    GreaterThan = 'gt',
    GreaterThanOrEqual = 'gte',
    Includes = 'includes',
    DoesNotInclude = 'notIncludes',
    StartsWith = 'startsWith',
    DoesNotStartWith = 'notStartsWith',
    EndsWith = 'endsWith',
    DoesNotEndWith = 'notEndsWith',
    Field1PercentageGteField2 = 'field1PercentageGteField2',
    Field1SumField2GtParameter = 'field1SumField2GtParameter',
    Field1MinusField2GtParameter = 'field1MinusField2GtParameter',
    Field1GteField2Percentage = 'field1GteField2Percentage',
}

export const ROWS_PER_PAGE_DEFAULT = 15;
export const ROWS_PER_PAGE_OPTIONS = [10, 15, 25, 50, 100];

export const FEASIBILITY_JSON_FILE_NAME = 'feasibility.json';
export const FEASIBILITY_KEYS = [
    "ImporteDeudaTotalCirculanteCIRBE",
    "ImporteMoraCIRBE",
    "ScoreOpenBanking",
    "IngresosElegibles",
    "GastosComprometidos",
    "DescubiertosCuenta",
    "IngresosRecurrentesTrimestrales",
    "NumeroRecobrosUltimoAno",
    "ImporteMedioGastosApuestas",
    "CantidadMesesGastosApuestas",
    "VariacionCaidaIngresos",
    "NumeroPagosPorFinancierasMensualmente",
    "SaldoMedioMinimoMensual6Meses",
    "LimiteCreditoAsignar",
    "Viable",
    "Fecha",
    "LimiteInicial",
    "CalculoDelLimite",
    "ViabilidadOpenBanking"
];

export const SUBSTATES_TO_REOPEN_BELENDER = [
    'created',
    'terms_and_conditions',
    'waiting_otp_seguridad_social',
    'invalid_otp_seguridad_social',
    'waiting_otp_aeat',
    'invalid_otp_aeat'
];

export const STATES_TO_HIDE_CONTINUE_OTP_BUTTON = [
    "Canceled",
    "Success",
    "Error"
];

export const STATES_TO_HIDE_CANCEL_OTP_BUTTON = [
    'Canceled',
    'Success',
    'Error'
];

export const EMAILS_FOR_CARDS = [
    "fernando.sanchez@experian.com",
    "sergio.sanchez@experian.com",
    "ivan.cedillo@experian.com",
    "pablo.alvarez@experian.com",
    "dragos.grecu@experian.com"
];

export const OKTA_SIGNIN_WIDGET_I18N = {
    en: {
        'primaryauth.title': 'Sign in to Open Data',
    },
    es: {
        'primaryauth.title': 'Iniciar sesión en Open Data',
        'primaryauth.username.placeholder': 'Email',
        'primaryauth.password.placeholder': 'Contraseña',
        'primaryauth.submit': 'Iniciar sesión',
        'remember': 'Recuérdame',
        'needhelp': '¿Necesita ayuda para iniciar sesión?',
        'forgotpassword': '¿Ha olvidado su contraseña?',
        'help': 'Ayuda',
        'password.reset': 'Restablecer contraseña',
        'password.forgot.email.or.username.placeholder': 'Email o nombre de usuario',
        'password.forgot.email.or.username.tooltip': 'Email o nombre de usuario',
        'password.forgot.sendEmail': 'Restablecer por email',
        'goback': 'Volver al inicio de sesión',
        'error.username.required': 'Introduzca un email',
        'error.password.required': 'Introduzca una contraseña',
        'oform.errorbanner.title': 'Hemos encontrado algunos errores. Por favor, revise el formulario y haga las correcciones necesarias.',
        'model.validation.field.blank': 'Este campo no puede dejarse en blanco',
        'error.auth.lockedOut': 'Su cuenta está bloqueada. Póngase en contacto con su administrador.',
        'errors.E0000004': 'No se puede iniciar sesión'

    },
    ca: {
        'primaryauth.title': 'Inicieu la sessió a Open Data',
        'primaryauth.username.placeholder': 'Email',
        'primaryauth.password.placeholder': 'Contrasenya',
        'primaryauth.submit': 'Inicia sessió',
        'remember': "Recorda'm",
        'needhelp': 'Necessiteu ajuda per iniciar sessió?',
        'forgotpassword': 'Heu oblidat la contrasenya?',
        'help': 'Ajuda',
        'password.reset': 'Restablir contrasenya',
        'password.forgot.email.or.username.placeholder': "Email o nom d'usuari",
        'password.forgot.email.or.username.tooltip': "Email o nom d'usuari",
        'password.forgot.sendEmail': 'Restablir per email',
        'goback': "Tornar a l'inici de sessió",
        'error.username.required': 'Introduzca un email',
        'error.password.required': 'Introduïu un email',
        'oform.errorbanner.title': 'Hem trobat algunes errades. Si us plau, reviseu el formulari i feu les correccions necessàries.',
        'model.validation.field.blank': 'Aquest camp no es pot deixar en blanc',
        'error.auth.lockedOut': 'El vostre compte està bloquejat. Poseu-vos en contacte amb el vostre administrador.',
        'errors.E0000004': 'No es pot iniciar sessió.'
    }
};
